/**
 * Container de página centralizado com folga lateral responsiva.
 *
 * - < 1700px (notebooks — inclui o caso 1536px de telas 1920×1080 @ 125%
 *   scaling): cap em `max-w-5xl` (1024px) → folga confortável nas laterais.
 * - >= 1700px (monitores externos grandes): cap em `max-w-screen-2xl` (1536px)
 *   → aproveita mais espaço; folga cresce conforme a tela aumenta.
 *
 * O breakpoint é 1700px (não o `2xl`=1536 do Tailwind) de propósito: 1536 é uma
 * largura COMUM de notebook (1920px @ 125%), então o tier-largo não pode ligar
 * lá — senão a folga some justamente no notebook.
 *
 * Padding: `px-4` (16px) base, `px-6` (24px) a partir de `sm`.
 * Compõe com flex/grid/gap/py inline no elemento que o usa.
 */
export const pageShell = 'mx-auto w-full max-w-5xl px-4 sm:px-6 min-[1700px]:max-w-screen-2xl';

export const cardOption = {
  active: 'border-brand bg-brand/5',
  inactive: 'border-line bg-white hover:border-muted',
  iconActive: 'bg-brand text-white',
  iconInactive: 'bg-faint text-muted',
  labelActive: 'text-brand',
  labelInactive: 'text-ink',
};

export const chip = {
  active: 'bg-brand text-white border-brand',
  inactive: 'bg-white text-ink border-line hover:border-muted',
};

export const segmented = {
  container: 'inline-flex w-full max-w-md rounded-2xl border-2 border-line overflow-hidden bg-white divide-x divide-line',
  item: 'flex-1 px-3 py-2 text-xs sm:text-sm font-semibold transition-colors',
  active: 'bg-brand text-white',
  inactive: 'bg-white text-ink hover:bg-faint',
};
